module.exports = __webpack_public_path__ + "img/4.99f63810.jpg";